import React from "react";
import StepImg1 from "../../../assets/images/stepImg1.svg";
import StepImg2 from "../../../assets/images/stepImg2.svg";
import StepImg3 from "../../../assets/images/stepImg3.svg";
import StepImg4 from "../../../assets/images/stepImg4.svg";
import StepImg5 from "../../../assets/images/stepImg5.svg";
import StepImg6 from "../../../assets/images/stepImg6.svg";

import styles from "./SelectionProcess.module.css";

export default function SelectionProcess() {
  const steps = [
    { title: "Call for Nominations", icon: StepImg1 },
    { title: "Submission Period", icon: StepImg2 },
    { title: "Screening Committee Review", icon: StepImg3 },
    { title: "Expert Evaluation", icon: StepImg4 },
    { title: "Final Approval", icon: StepImg5 },
    { title: "Announcement & Ceremony", icon: StepImg6 },
  ];

  return (
    <>
      <h3>
        Selection <span>Process</span>
      </h3>
      <h5>
        A transparent and rigorous evaluation process ensures fair recognition
        of excellence
      </h5>

      <div className={styles.timeline}>
        <div className={styles.step}>
          <div className={styles.circle}></div>
          <div className={styles.line}></div>
        </div>
        {steps.map((step, index) => (
          <div key={index} className={styles.step}>
            <div className={styles.iconWhiteOuter}>
              <div className={styles.icon}>
                <img src={step.icon} alt={step.title} />
              </div>
            </div>
            <div className={styles.content}>{step.title}</div>
            {index !== steps.length - 1 && <div className={styles.line}></div>}
          </div>
        ))}
      </div>
    </>
  );
}
